import PropTypes from 'prop-types';

const Draft = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M6.125 17.5a.625.625 0 0 1-.625.625H4.25A1.25 1.25 0 0 1 3 16.875v-2.5a.625.625 0 1 1 1.25 0v2.5H5.5a.625.625 0 0 1 .625.625M16.75 6.875v3.75a.624.624 0 1 1-1.25 0V7.5h-3.75a.625.625 0 0 1-.625-.625v-3.75H9.25a.625.625 0 0 1 0-1.25h2.5a.63.63 0 0 1 .442.183l4.375 4.375a.63.63 0 0 1 .183.442m-4.375-.625h2.241l-2.241-2.241zm-6.25-4.375H4.25A1.25 1.25 0 0 0 3 3.125V5a.625.625 0 0 0 1.25 0V3.125h1.875a.625.625 0 0 0 0-1.25m10 11.25a.624.624 0 0 0-.625.625v3.125h-.625a.624.624 0 1 0 0 1.25h.625a1.25 1.25 0 0 0 1.25-1.25V13.75a.624.624 0 0 0-.625-.625m-12.5-1.25a.625.625 0 0 0 .625-.625V8.125a.625.625 0 0 0-1.25 0v3.125a.625.625 0 0 0 .625.625m8.125 5H8.625a.625.625 0 1 0 0 1.25h3.125a.624.624 0 1 0 0-1.25"
            fill={color}
        />
    </svg>
);

export default Draft;

Draft.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
